var map = {
	"./": 1858,
	"./Doctor-1.png": 8175,
	"./Frame.png": 2246,
	"./aoc-logo.png": 6315,
	"./confirm_error.png": 7341,
	"./confirm_success.png": 3178,
	"./end.svg": 5145,
	"./icon-annotate.svg": 9247,
	"./icon-calendar.svg": 4920,
	"./icon-clock.svg": 4186,
	"./icon-edit.svg": 736,
	"./icon-error.svg": 4170,
	"./icon-exclamation.svg": 2043,
	"./icon-filter-new.svg": 9922,
	"./icon-filter.svg": 8352,
	"./icon-lock.svg": 1808,
	"./icon-participant.svg": 3673,
	"./icon-plus.svg": 3254,
	"./icon-rom.svg": 8271,
	"./icon-share.svg": 4231,
	"./icon-stop.svg": 5860,
	"./icon-sucess.svg": 6883,
	"./icon-unlock.svg": 5076,
	"./icon-user-times.svg": 7257,
	"./icon-video-session.svg": 350,
	"./icon-viewimg.svg": 5129,
	"./icon_clear.svg": 5640,
	"./icon_header_user.svg": 337,
	"./index": 1858,
	"./index.js": 1858,
	"./microphone.svg": 7518,
	"./mouse-logo.png": 76,
	"./mute.svg": 9667,
	"./no-video.svg": 565,
	"./no_image.png": 8148,
	"./no_image.svg": 6890,
	"./search.svg": 8499,
	"./sportslinkmd-logo.jpeg": 7194,
	"./sportslinkmd-logo.png": 8166,
	"./sportsmed-logo-big.gif": 3002,
	"./sportsmed-logo.gif": 5132,
	"./sportsmed-logo.png": 4091,
	"./sportsmed-logo.svg": 3436,
	"./svg-sprite.svg": 9626,
	"./theos-logo.png": 9383,
	"./theos-logo.webp": 2009,
	"./video-camera.svg": 1551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1964;